import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { Check, X, Star, Minus } from 'lucide-react';
type Cell = string | 'check' | 'x' | 'star' | 'dash';
interface Row {
  feature: string;
  fba: Cell;
  fbm: Cell;
  completo: Cell;
}
export function ComparativaSistema() {
  const rows: Row[] = [{
    feature: 'Curso Amazon FBA',
    fba: 'check',
    fbm: 'x',
    completo: 'check'
  }, {
    feature: 'Curso Amazon FBM',
    fba: 'x',
    fbm: 'check',
    completo: 'check'
  }, {
    feature: 'Bonos Premium',
    fba: 'Algunos',
    fbm: 'Algunos',
    completo: 'Todos'
  }, {
    feature: 'Aprendes ambos modelos',
    fba: 'x',
    fbm: 'x',
    completo: 'check'
  }, {
    feature: 'Actualizaciones futuras',
    fba: 'check',
    fbm: 'check',
    completo: 'check'
  }, {
    feature: 'Acceso inmediato',
    fba: 'check',
    fbm: 'check',
    completo: 'check'
  }, {
    feature: 'Mejor relación calidad-precio',
    fba: 'x',
    fbm: 'x',
    completo: 'star'
  }, {
    feature: 'Ahorro',
    fba: 'dash',
    fbm: 'dash',
    completo: '💰 Ahorras $7.99'
  }];
  const checkout = {
    fba: 'https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos',
    fbm: 'https://43skvt-1y.myshopify.com/products/aprende-a-vender-en-amazon-fbm-desde-cero',
    completo: 'https://43skvt-1y.myshopify.com/products/sistema-completo-de-ventas-en-amazon-fba-fbm-2026'
  };
  const open = (url: string) => window.open(url, '_blank', 'noopener,noreferrer');
  const renderCell = (value: Cell, highlight = false) => {
    if (value === 'check') return <Check className={`w-5 h-5 mx-auto ${highlight ? 'text-brand-green' : 'text-brand-green'}`} strokeWidth={3} data-id="element-150" />;
    if (value === 'x') return <X className="w-5 h-5 mx-auto text-brand-text/30" strokeWidth={3} data-id="element-151" />;
    if (value === 'star') return <Star className="w-5 h-5 mx-auto text-brand-gold fill-brand-gold" data-id="element-152" />;
    if (value === 'dash') return <Minus className="w-4 h-4 mx-auto text-brand-text/30" data-id="element-153" />;
    return <span className={`text-sm font-semibold ${highlight ? 'text-brand-green' : 'text-brand-text/70'}`} data-id="element-154">
        {value}
      </span>;
  };
  return <section className="bg-brand-white py-16 md:py-24 px-4 sm:px-6" data-id="element-155">
      <div className="max-w-5xl mx-auto" data-id="element-156">
        <FadeIn data-id="element-157">
          <div className="text-center mb-10 md:mb-14" data-id="element-158">
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold text-brand-green mb-4 tracking-tight" data-id="element-159">
              ¿Cuál opción te conviene más?
            </h2>
            <p className="text-base sm:text-lg text-brand-text/65 max-w-2xl mx-auto leading-relaxed" data-id="element-160">
              Compara rápidamente todo lo que incluye cada opción y descubre por
              qué la mayoría de nuestros estudiantes eligen el Sistema Completo.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-161">
          <div className="overflow-x-auto pb-2 -mx-4 px-4 sm:mx-0 sm:px-0" data-id="element-162">
            <div className="min-w-[640px]" data-id="element-163">
              {/* Header */}
              <div className="grid grid-cols-[1.4fr_1fr_1fr_1.2fr] gap-3 sm:gap-4 items-stretch mb-3" data-id="element-164">
                <div className="flex items-end pb-4" data-id="element-165">
                  <span className="text-sm font-bold uppercase tracking-wider text-brand-text/50" data-id="element-166">
                    Características
                  </span>
                </div>

                {/* FBA */}
                <div className="text-center rounded-2xl bg-brand-beige/50 border border-brand-text/10 px-3 py-5" data-id="element-167">
                  <p className="text-base font-bold text-brand-green mb-1" data-id="element-168">
                    Amazon FBA
                  </p>
                  <p className="text-2xl font-bold text-brand-text" data-id="element-169">$16.99</p>
                </div>

                {/* FBM */}
                <div className="text-center rounded-2xl bg-brand-beige/50 border border-brand-text/10 px-3 py-5" data-id="element-170">
                  <p className="text-base font-bold text-brand-green mb-1" data-id="element-171">
                    Amazon FBM
                  </p>
                  <p className="text-2xl font-bold text-brand-text" data-id="element-172">$15.99</p>
                </div>

                {/* Sistema Completo — highlighted */}
                <div className="relative text-center rounded-2xl bg-brand-green/5 border-2 border-brand-gold px-3 py-5 shadow-[0_18px_45px_-18px_rgba(200,169,106,0.7)]" data-id="element-173">
                  <span className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1 bg-brand-gold text-brand-green text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded-full whitespace-nowrap shadow-sm" data-id="element-174">
                    <Star className="w-3 h-3 fill-brand-green" data-id="element-175" />
                    Más vendido
                  </span>
                  <p className="text-base font-bold text-brand-green mb-1 mt-1" data-id="element-176">
                    ⭐ Sistema Completo
                  </p>
                  <p className="text-2xl font-bold text-brand-green" data-id="element-177">$24.99</p>
                </div>
              </div>

              {/* Rows */}
              <div className="rounded-2xl overflow-hidden border border-brand-text/10" data-id="element-178">
                {rows.map((row, i) => <div key={i} className={`grid grid-cols-[1.4fr_1fr_1fr_1.2fr] gap-3 sm:gap-4 items-center ${i % 2 === 0 ? 'bg-white' : 'bg-brand-beige/30'}`} data-id="element-179">
                    <div className="px-4 py-4 text-sm font-medium text-brand-text/80" data-id="element-180">
                      {row.feature}
                    </div>
                    <div className="px-2 py-4 text-center" data-id="element-181">
                      {renderCell(row.fba)}
                    </div>
                    <div className="px-2 py-4 text-center" data-id="element-182">
                      {renderCell(row.fbm)}
                    </div>
                    <div className="px-2 py-4 text-center bg-brand-green/5 border-x-2 border-brand-gold/40" data-id="element-183">
                      {renderCell(row.completo, true)}
                    </div>
                  </div>)}
              </div>

              {/* Buttons */}
              <div className="grid grid-cols-[1.4fr_1fr_1fr_1.2fr] gap-3 sm:gap-4 items-center mt-5" data-id="element-184">
                <div data-id="element-185" />
                <div className="text-center" data-id="element-186">
                  <button onClick={() => open(checkout.fba)} className="w-full text-sm font-semibold text-brand-green border border-brand-green/30 rounded-xl py-3 hover:bg-brand-green/5 transition-colors" data-id="element-187">
                    Comprar
                  </button>
                </div>
                <div className="text-center" data-id="element-188">
                  <button onClick={() => open(checkout.fbm)} className="w-full text-sm font-semibold text-brand-green border border-brand-green/30 rounded-xl py-3 hover:bg-brand-green/5 transition-colors" data-id="element-189">
                    Comprar
                  </button>
                </div>
                <div className="text-center" data-id="element-190">
                  <Button onClick={() => open(checkout.completo)} className="w-full bg-brand-green hover:bg-brand-green/90 text-white text-sm sm:text-base font-bold px-3 py-4 shadow-xl shadow-brand-green/30 ring-2 ring-brand-gold/40 leading-tight" data-id="element-191">
                    QUIERO EL SISTEMA COMPLETO
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Recommendation box */}
        <FadeIn delay={0.15} data-id="element-192">
          <div className="mt-10 bg-brand-green/5 border border-brand-gold/40 rounded-2xl p-6 sm:p-8 max-w-3xl mx-auto" data-id="element-193">
            <div className="flex items-center gap-2 mb-3" data-id="element-194">
              <Star className="w-5 h-5 text-brand-gold fill-brand-gold" data-id="element-195" />
              <p className="text-sm font-bold uppercase tracking-widest text-brand-green" data-id="element-196">
                Nuestra recomendación
              </p>
            </div>
            <p className="text-sm sm:text-base text-brand-text/80 leading-relaxed mb-3" data-id="element-197">
              Si tu objetivo es aprender a vender en Amazon de forma
              profesional, ahorrar dinero y tener acceso a ambos métodos de
              venta desde el primer día, el{' '}
              <span className="font-semibold text-brand-green" data-id="element-198">
                Sistema Completo
              </span>{' '}
              es la opción con mayor valor.
            </p>
            <p className="text-sm sm:text-base text-brand-text/80 leading-relaxed" data-id="element-199">
              Obtienes más contenido, todos los bonos incluidos y además ahorras{' '}
              <span className="font-semibold text-brand-green" data-id="element-200">$7.99</span>{' '}
              frente a comprar ambos cursos por separado.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}